import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { TypographyLeftMenu } from '../style/typography';
import { CheckboxBase } from '../style/checkbox';

const FilterAccordion = ({
  label,
  labelTitle,
  checked,
  onCheck,
  children,
  expanded,
  onChange,
  nested = false, // 地方・市町村用にはtrue
}) => {
  return (
    <Accordion
      disableGutters
      square
      expanded={expanded}
      onChange={onChange}
      sx={{
        bgcolor: 'black',
        color: 'white',
        mb: 0,
        '& .MuiAccordionSummary-content': {
          margin: 0,
        },
        '& .MuiAccordionSummary-root': {
          minHeight: 5,
          paddingY: 0,
          padding: '0px 0px 0px 9px',
        },
        '& .MuiAccordionDetails-root': {
          padding: '0px 0px 0px 10px',
        },
      }}
    >
      <AccordionSummary
      sx={{ justifyContent: 'flex-start', }}
       expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}>
        <FormControlLabel sx={{marginRight:'0px'}}
          label={
            <TypographyLeftMenu
              sx={{
                fontSize: { xs: '0.75rem', sm: '0.75rem', md: 'clamp(0.375rem, -0.3rem + 1.2vw, 0.75rem)' },
              }}
              noWrap
              title={labelTitle}
            >
              {label}
            </TypographyLeftMenu>
          }
          control={
            <CheckboxBase
              checked={checked}
              onClick={(e) => e.stopPropagation()}
              onChange={onCheck}
            />
          }
          onClick={(e) => e.stopPropagation()}
        />
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default FilterAccordion;
